import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';


@Component({
  selector: 'multicheckbox-wrapper',
  templateUrl: './multicheckbox-wrapper.component.html',
  imports: [FormlyModule]
})
export class MulticheckboxWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef, static: true }) fieldComponent: ViewContainerRef;
}
